module.exports = __webpack_public_path__ + "fonts/WorkSans-Light.b102303.ttf";